const AboutContent = {
  aboutMe: {
    paras: [
      "I am an eternal student and practitioner of all things 'design and visual communication'. I have worked on many different design projects including corporate identity, visual branding, marketing campaigns, company websites, web applications, e-commerce platforms, and enterprise applications.",
      "I am passionate about the UX practices of user-research, ideation, prototyping, front-end build, testing and validation of ideas. ",
      "I view myself as both a maker and strategist. A fulfilling role for me is where I apply my skills and experience to achieve measurable impact for businesses and customers.",
    ],
  },
};

export default AboutContent;
